// src/components/trials/TrialDetails.tsx

import React, { FC } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';

type SiteLocation = {
  city?: string;
  state?: string;
  zip?: string;
  lat?: number;
  lng?: number;
};

type ClinicalTrial = {
  nctId?: string;
  description?: string;
  briefSummary?: string;
  eligibilityCriteria?: string;
  healthyVolunteers?: boolean;
  sex?: string;
  minimumAge?: string;
  sponsorInfo?: { leadSponsor?: { name?: string } };
  site_location: SiteLocation[];
};

export type TrialDetailsProps = {
  trial: ClinicalTrial;
  onBack: () => void;
};

const TrialDetails: FC<TrialDetailsProps> = ({ trial, onBack }) => {
  return (
    <Box sx={{ py: 5, width: '100%', height: '100%', overflow: 'auto', backgroundColor:'white' }}>
      <Container>
        <Button onClick={onBack} variant="text" sx={{backgroundColor:'rgb(219, 103, 32)', color:'white'}}>
          ← Back to trials
        </Button>

        <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold' }}>
          {trial.description ?? trial.nctId}
        </Typography>

        <Typography sx={{ mt: 1 }}>
          <b>NCTID:</b> {trial.nctId}
        </Typography>

        <Typography sx={{ mt: 1 }}>
          <b>Sponsor:</b> {trial.sponsorInfo?.leadSponsor?.name}
        </Typography>

        {trial.briefSummary && (
          <>
            <Typography variant="h6" sx={{ mt: 3 }}>
              Brief Summary
            </Typography>
            <Typography>{trial.briefSummary}</Typography>
          </>
        )}

        {trial.eligibilityCriteria && (
          <>
            <Typography variant="h6" sx={{ mt: 3 }}>
              Eligibility Criteria
            </Typography>
            <Typography sx={{ whiteSpace: 'pre-wrap' }}>
              {trial.eligibilityCriteria}
            </Typography>
            <Typography sx={{ mt: 1 }}>
                <b>Gender:</b> {trial.sex}
            </Typography>
            <Typography sx={{ mt: 1 }}>
                <b>Minimum Age:</b> {trial.minimumAge}
            </Typography>
            <Typography sx={{ mt: 1 }}>
                <b>Healthy Volunteers:</b> {trial.healthyVolunteers ? "Yes" : "No"}
            </Typography>
          </>
        )}

        <Typography variant="h6" sx={{ mt: 3 }}>
          Locations
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          {trial.site_location.map((l, i) => (
            <li key={i}>
              {l.city ?? ''}{l.city ? ', ' : ''}
              {l.state ?? ''} {l.zip ?? ''}
            </li>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default TrialDetails;
